import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import ProductFinderModal from '../../modals/ProductFinderModal';
import initTreeView from '../../../services/initTreeView';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { getApiData, postApiData } from '../../../services/apiService';
import { TabView, TabPanel } from 'primereact/tabview';
import { Checkbox } from 'primereact/checkbox';
 
export default function RolesForm (){
    const { role_id } = useParams();
    const [permission_list, setPermissionList] = useState([]);
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('New Role');
    const [table_items, setTableItems] = useState([]);
    /** Modals */
    const [product_modal, setProductModal] = useState(0);
    
    let default_data = {
        "id": "",
        "account_id": "",
        "name": "",
        "description": "",
        "permissions": ""
    }
    const [form_data, setFormData] = useState(default_data);
    const [adjustment_items, setAdjustmentItems] = useState([]);
   
    useEffect(() => {
        if(role_id){
            setPageTitle('Edit Role')
            fetchData(role_id)
        }else{
            fetchEnums()
        }
    }, []);

    useEffect(() => {
        initTreeView()
        //computeTotals();
    }, [adjustment_items, form_data.type_id]);

    useEffect(() => {

    }, [form_data.shipping_status_id]);

    async function fetchData(){
        setLoading(1)
        const endpoint = helpers.createUrl(`V1/roles/${role_id}`)
        const res = await getApiData(endpoint, false)

        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/account/roles/manage");
                }
            })
        }
        else{
            setFormData(res)
            fetchEnums()
        }
    }

    async function fetchEnums(){
        setLoading(1)
        const endpoint = helpers.createUrl(`V1/permissions`)
        const res = await getApiData(endpoint)

        if(res.status !== 'error'){
            setPermissionList(res)
            setLoading(0)
        }
        else{
            setLoading(0)
        }
    }

    async function submit(){
        const validate = validateForm();

        if(Object.keys(validate).length){
            Swal.fire({
                text: 'Please complete all required fields in the form.',
                icon: "error",
                confirmButtonText: "OK",
            })
            return
        }
        setLoading(1)
        let endpoint = helpers.createUrl(`V1/roles/create`)
        if(role_id){
            endpoint = helpers.createUrl(`V1/roles/${role_id}`)
        }
        
        const res = await postApiData(endpoint,form_data)
        if(res.error_code){
            if(res.data){
                setErrors( res.data );
            }else{
                setErrors([])
            }
            setLoading(0)
        }
        else{
            let id = role_id;
            if(!id){
                id = res.data.id
            }

            Swal.fire({
                title: "Success",
                text: res.message,
                icon: "success",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace(`/account/roles/${id}/edit`);
                    return;
                }
            })
        }
    }

    const PermissionItems = ({target_group = []}) => {
        const filteredPermissions = permission_list.filter(permission => 
            target_group.includes(permission.group)
        );
        
        const handleLabelClick = (permission) => {
            const isChecked = form_data.permissions.includes(permission.id);
            const simulatedEvent = {
                target: {
                    value: permission.id,
                    checked: !isChecked, 
                },
                preventDefault: () => {}, 
            };
            
            selectSinglePermission(simulatedEvent);
        };

        return (
        <div>
            {filteredPermissions.map((permission, index) => {
                // Create a unique ID string for the checkbox and label
                const uniqueId = `permission-${permission.name.replace(/\s+/g, '-')}`;

                return (
                    <div className='d-flex' key={`permission-${permission.name}`}>
                        <Checkbox 
                            name="permission"
                            id={uniqueId} // Checkbox ID
                            onChange={selectSinglePermission}
                            value={permission.id} 
                            checked={form_data.permissions.includes(permission.id)}
                        />
                        
                        <div 
                            onClick={() => handleLabelClick(permission)}
                            className='ml-2 pointer' 
                        >
                            <span className="mb-0">{permission.display_name}</span>
                        </div>
                    </div>
                );
            })}
        </div>
        )
    }

    const SelectAllPermission = ({target_group = []}) => {
        const filteredPermissions = permission_list.filter(permission => 
            target_group.includes(permission.group)
        ).map(permission => permission.id);
        
        const handleLabelClick = (permissionIds) => {
            const isChecked = filteredPermissions.some(id => form_data.permissions.includes(id));

            const simulatedEvent = {
                target: {
                    value: permissionIds,
                    checked: !isChecked, 
                },
                preventDefault: () => {}, 
            };
            
            selectMultitplePermission(simulatedEvent);
        };
        return (
            <div className='d-flex'>
                <Checkbox 
                    name="permission"
                    id={`permission-selectall`} // Checkbox ID
                    onChange={selectMultitplePermission}
                    value={filteredPermissions} 
                    checked={filteredPermissions.every(id => form_data.permissions.includes(id))}
                />
                
                <div 
                    onClick={() => handleLabelClick(filteredPermissions)}
                    className='ml-2 pointer' 
                >
                    <span className="mb-0">Select All</span>
                </div>
            </div>
        );
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        if(name === 'type_id'){
            new_state.warehouse_id = '';
        }
        if(name === 'warehouse_id'){
            setAdjustmentItems([])
        }

        setFormData({ ...form_data, ...new_state });
    }

    function selectSinglePermission(e) {
        const permissionId = Number(e.target.value); 

        // Use the function with the state updater
        setFormData(prevFormData => {
            return togglePermissionInState(prevFormData, [permissionId]);
        });
    }

    function selectMultitplePermission(e) {
        const permissionIds = e.target.value//JSON.parse(e.target.value).map(Number);
        setFormData(prevFormData => {
            return togglePermissionInState(prevFormData, permissionIds);
        });
    }

    function togglePermissionInState(prevFormData, permissionIds) {
        const currentPermissions = prevFormData.permissions;

        // Determine if all permissionIds are already selected
        const allSelected = permissionIds.every(id => currentPermissions.includes(id));

        let updatedPermissions;
        if (allSelected) {
            // Remove all permissionIds
            updatedPermissions = currentPermissions.filter(id => !permissionIds.includes(id));
        } else {
            // Add missing permissionIds
            const newPermissions = permissionIds.filter(id => !currentPermissions.includes(id));
            updatedPermissions = [...currentPermissions, ...newPermissions];
        }

        return {
            ...prevFormData,
            permissions: updatedPermissions,
        };
    }

    function validateForm(){
        let new_errors = {...errors}

        if(!form_data.name){
            new_errors['name'] = ["The name field is required."]
        }
        else{
            delete new_errors['name'];
        }

        if(!form_data.permissions.length){
            new_errors['permissions'] = ["At least one permission must be selected."]
        }
        else{
            delete new_errors['permissions'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    return (
        <Layout page_title={page_title} menu="roles" breadcrumbs={true} parent_text="Account">
                <div className="content">
                    <div className="container-fluid pb-5" style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>
                        <form id="pr-form">
                            <div className="row mb-2 d-flex align-items-stretch">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body pt-md-5">
                                            <div className="row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-2">
                                                    <label>Name<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-5 form-group">
                                                    <InputText
                                                        id="name" 
                                                        name="name" 
                                                        value={form_data.name}
                                                        className="mb-0"
                                                        onChange={inputChange}
                                                        placeholder="Role Name"
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="name" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12"></div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-2">
                                                    <label>Description</label>
                                                </div>
                                                <div className="col-md-4 form-group">
                                                    <InputTextArea
                                                        id="description" 
                                                        name="description" 
                                                        value={form_data.description}  
                                                        tagClass="form-control"
                                                        onChange={inputChange}
                                                        rows={2}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="description" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="so-item-container mt-5" className="row">
                                <div className="col-12">
                                    <div className="card card-primary card-outline w-100">
                                        <div className="card-header">
                                            <div className='font-weight-bold'>Permissions</div>
                                            <RenderErrors 
                                                errors={errors} 
                                                name="permissions" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="card-body">
                                            <div className="row d-flex">
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            System

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['admin', 'account-owner']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['admin', 'account-owner']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            User Management

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['user']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['user']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Role Management

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['role']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['role']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Permission Management

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['permission']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['permission']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Store Management

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['store']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['store']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Employee Management

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['employee']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['employee']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Inventory

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['inventory']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['inventory']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Inventory Adjustment

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['inventory-adjustment']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['inventory-adjustment']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Product Unit

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['product-unit']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['product-unit']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Sales Order Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['sales-order']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['sales-order']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Invoice Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['invoice']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['invoice']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Sales Return Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['sales-return']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['sales-return']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Payment Receiving Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['payment-receive']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['payment-receive']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Shipment Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['shipment']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['shipment']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Customer Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['customer']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['customer']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Purchase Order Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['purchase-order']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['purchase-order']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Bills Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['bill']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['bill']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Purchase Receive Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['purchase-receive']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['purchase-receive']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Payment Made Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['payment-made']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['payment-made']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Vendor Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['vendor']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['vendor']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Category Maintenance

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['category']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['category']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Variant Type Maintenance

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['variant-type']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['variant-type']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Brand Maintenance

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['brand']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['brand']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Courier Maintenance

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['courier']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['courier']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Tax Rate Maintenance

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['tax-rate']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['tax-rate']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Discount Rate Maintenance

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['discount-rate']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['discount-rate']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            PolarCare Module

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['service-hub']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['service-hub']} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 d-flex">
                                                    <div className="card w-100">
                                                        <div className="card-header">
                                                            Tools

                                                            <div className='float-right'>
                                                                <SelectAllPermission target_group={['tools']}/>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <PermissionItems target_group={['tools']} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='text-right mt-3'>
                                <button type='button' className='btn btn-success mr-3 ' onClick={(e) => submit(1)}>Save</button>
                                <Link className='btn btn-outline-dark' to="/account/roles/manage">Cancel</Link>                   
                            </div>
                        </form>
                    </div>
                </div>
        </Layout>
    )
}